(() => {
  const STYLE_ID = 'sofa-gallery-designer-form-styles';
  const ROOT_SELECTOR = '.contact-form--designer .contact__app-form shopify-forms-embed';
  const CONTACT_STYLE_ID = 'sofa-gallery-contact-form-styles';
  const CONTACT_TRACKING_FORM_ID = '1114611';
  const CONTACT_ROOT_SELECTOR =
    '.contact-form:not(.contact-form--designer) .contact__app-form shopify-forms-embed';

  const thankYouTypography = `
    #app-embed[data-current-step='success'] [data-testid='banner-success'] h2 {
      font-size: 48px !important;
      line-height: 1.2 !important;
    }

    #app-embed[data-current-step='success'] [data-testid='banner-success'] p {
      font-size: 22px !important;
      line-height: 1.5 !important;
    }

    @media (max-width: 767px) {
      #app-embed[data-current-step='success'] [data-testid='banner-success'] h2 {
        font-size: 36px !important;
      }

      #app-embed[data-current-step='success'] [data-testid='banner-success'] p {
        font-size: 18px !important;
      }
    }
  `;

  const syncReassurance = (embed, shadow) => {
    const reassurance = embed.closest('.contact-form')?.querySelector('.contact__reassurance--app');
    const appRoot = shadow.querySelector('#app-embed[data-current-step]');
    if (!reassurance || !appRoot) return;

    reassurance.hidden = appRoot.dataset.currentStep !== 'form';
  };

  const useShopifyLabelAsPlaceholder = (shadow, field) => {
    if (!field || field.placeholder) return;

    const label = field.id
      ? shadow.querySelector(`label[for='${CSS.escape(field.id)}']`)
      : null;
    const placeholder = label?.textContent?.replace(/\s*\*\s*$/, '').trim();

    if (placeholder) field.placeholder = placeholder;
  };

  const publishPinterestSubmission = (embed, shadow) => {
    const appRoot = shadow.querySelector('#app-embed[data-current-step]');
    const isSuccessful = appRoot?.dataset.currentStep === 'success';

    if (!isSuccessful) {
      embed.sofaGalleryPinterestSubmissionPublished = false;
      return;
    }

    if (embed.sofaGalleryPinterestSubmissionPublished) return;

    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return;

    const formsId = embed.closest('[data-forms-id]')?.dataset.formsId || '';
    const formId = formsId.replace(/^forms-root-/, '');

    embed.sofaGalleryPinterestSubmissionPublished = true;

    Promise.resolve(
      publish.call(window.Shopify.analytics, 'sofagallery:pinterest_form_submitted', {
        form_id: formId,
        form_name: 'pinterest_lead_form',
        page_location: window.location.href,
        email: embed.sofaGalleryPinterestContactData?.email || '',
        phone: embed.sofaGalleryPinterestContactData?.phone || '',
        newsletter_consent: embed.sofaGalleryPinterestContactData?.newsletterConsent || false,
      })
    ).catch(() => {
      embed.sofaGalleryPinterestSubmissionPublished = false;
    });
  };

  const capturePinterestContactData = (embed, shadow) => {
    const form = shadow.querySelector('form');
    if (!form || form.dataset.sofaGalleryContactCapture) return;

    form.dataset.sofaGalleryContactCapture = 'true';
    form.addEventListener(
      'submit',
      () => {
        embed.sofaGalleryPinterestContactData = {
          email: shadow.querySelector('#email')?.value?.trim() || '',
          phone: shadow.querySelector('#phone_number')?.value?.trim() || '',
          newsletterConsent: Boolean(
            shadow.querySelector("fieldset[name='custom#marketing_opt_in'] input:checked")
          ),
        };
      },
      true
    );
  };

  const getShopifyFormId = (embed) => {
    const formsId = embed.closest('[data-forms-id]')?.dataset.formsId || '';
    return formsId.replace(/^forms-root-/, '');
  };

  const captureContactFormData = (embed, shadow) => {
    if (getShopifyFormId(embed) !== CONTACT_TRACKING_FORM_ID) return;

    const form = shadow.querySelector('form');
    if (!form || form.dataset.sofaGalleryContactPageCapture) return;

    form.dataset.sofaGalleryContactPageCapture = 'true';
    form.addEventListener(
      'submit',
      () => {
        embed.sofaGalleryContactPageData = {
          email: shadow.querySelector('#email')?.value?.trim() || '',
          phone: shadow.querySelector('#phone_number')?.value?.trim() || '',
        };
      },
      true
    );
  };

  const publishContactFormSubmission = (embed, shadow) => {
    const formId = getShopifyFormId(embed);
    if (formId !== CONTACT_TRACKING_FORM_ID) return;

    const appRoot = shadow.querySelector('#app-embed[data-current-step]');
    const isSuccessful = appRoot?.dataset.currentStep === 'success';

    if (!isSuccessful) {
      embed.sofaGalleryContactPageSubmissionPublished = false;
      return;
    }

    if (embed.sofaGalleryContactPageSubmissionPublished) return;

    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return;

    embed.sofaGalleryContactPageSubmissionPublished = true;

    Promise.resolve(
      publish.call(window.Shopify.analytics, 'sofagallery:contact_form_submitted', {
        form_id: formId,
        form_name: 'contact_form',
        page_location: window.location.href,
        email: embed.sofaGalleryContactPageData?.email || '',
        phone: embed.sofaGalleryContactPageData?.phone || '',
      })
    ).catch(() => {
      embed.sofaGalleryContactPageSubmissionPublished = false;
    });
  };

  const styles = `
    :host {
      --app-embed-padding-x: 0px !important;
      --app-embed-padding-y: 0px !important;
      --inline-container-max-width: 528px !important;
      --container-max-w: 528px !important;
      --form-field-border-radius: 0px !important;
      --button-border-radius: 0px !important;
      --body-text-color: #887158 !important;
      --heading-text-color: #887158 !important;
      --form-text-color: #887158 !important;
      --form-placeholder-color: #cbbdac !important;
      --button-background-color: #887158 !important;
      display: block !important;
      width: 100% !important;
      color: #887158 !important;
      direction: rtl !important;
      font-family: inherit !important;
    }

    [data-sizing='form-wrapper'],
    [role='dialog'],
    [class*='_inline_'],
    [class*='_gridItemContent_'] {
      width: 100% !important;
      max-width: none !important;
      padding-right: 0 !important;
      padding-left: 0 !important;
    }

    [class*='_formHeader_'] {
      margin: 0 0 16px !important;
    }

    h1, h2, h3, [role='heading'] {
      margin: 0 !important;
      color: #887158 !important;
      font-family: inherit !important;
      font-size: 32px !important;
      font-weight: 400 !important;
      line-height: 1.2 !important;
      text-align: center !important;
    }

    form {
      display: flex !important;
      width: 100% !important;
      max-width: none !important;
      gap: 22px !important;
      direction: rtl !important;
      padding: 0 20px !important;
      box-sizing: border-box;
    }

    form > div:has(#first_name) { order: 1; }
    form > div:has(#phone_number) { order: 2; }
    form > div:has(button[aria-labelledby*='current_projects']) { order: 3; }
    form > div:has(input[name='phoneConsent']) { order: 4; }
    form > fieldset[name='custom#marketing_opt_in'] { order: 4; }
    form > button[type='submit'] { order: 5; }

    [class*='_formFieldContainer_'],
    [class*='_formPhoneInputContainer_'],
    [class*='_selectContainer_'] {
      width: 100% !important;
      max-width: none !important;
    }

    [class*='_formPhoneInputContainer_'] {
      display: block !important;
    }

    .phone-country-selector {
      display: none !important;
    }

    input:not([type='checkbox']):not([type='radio']) {
      box-sizing: border-box !important;
      width: 100% !important;
      height: 76px !important;
      min-height: 76px !important;
      padding: 0 20px !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: #fff !important;
      box-shadow: 0 8px 22px rgba(52, 44, 35, 0.22) !important;
      color: #887158 !important;
      font-family: inherit !important;
      font-size: 20px !important;
      text-align: center !important;
    }

    input::placeholder {
      color: #cbbdac !important;
      opacity: 1 !important;
    }

    input#email,
    input[type='email'] {
      direction: rtl !important;
      unicode-bidi: plaintext !important;
      text-align: right !important;
    }

    label[for='first_name'],
    label[for='phone_number'] {
      display: none !important;
    }

    p[id$='selector-label'] {
      margin: 0 0 14px !important;
      color: #887158 !important;
      font-family: inherit !important;
      font-size: 21px !important;
      font-weight: 600 !important;
      line-height: 1.3 !important;
      text-align: center !important;
    }

    button[aria-labelledby*='current_projects'] {
      box-sizing: border-box !important;
      width: 100% !important;
      height: 76px !important;
      min-height: 76px !important;
      padding: 0 20px !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: #fff !important;
      box-shadow: 0 8px 22px rgba(52, 44, 35, 0.22) !important;
      color: #cbbdac !important;
      font-family: inherit !important;
      font-size: 20px !important;
      justify-content: center !important;
      text-align: center !important;
    }
    
    button[aria-labelledby*='current_projects'] * {
      text-align: center !important;
      justify-content: center !important;
    }
    
    div[id*=current_projects-selector-dropdown] div {
      text-align: start !important;
    }

    button[aria-labelledby*='current_projects'] [id$='selector-value']:empty::before {
      content: 'בחרו אפשרות';
    }

    [class*='_consentCheckboxContainer_'] {
      width: 100% !important;
    }

    fieldset[name='custom#marketing_opt_in'] {
      box-sizing: border-box !important;
      width: 100% !important;
      min-width: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      border: 0 !important;
    }

    fieldset[name='custom#marketing_opt_in'] > legend {
      display: none !important;
    }

    fieldset[name='custom#marketing_opt_in'] [class*='_verticalLayout_'] {
      width: 100% !important;
    }

    label:has(input[name='phoneConsent']),
    fieldset[name='custom#marketing_opt_in'] label {
      display: flex !important;
      justify-content: start !important;
      align-items: center !important;
      gap: 7px !important;
      color: #887158 !important;
      direction: rtl !important;
      text-align: right !important;
    }
    
    label:has(input[name='phoneConsent']) span,
    fieldset[name='custom#marketing_opt_in'] label span {
      font-family: inherit !important;
      font-size: 21px !important;
    }

    input[type='checkbox'] {
      width: 14px !important;
      height: 14px !important;
      min-width: 14px !important;
      margin: 0 !important;
      accent-color: #887158 !important;
    }

    button[type='submit'] {
      box-sizing: border-box !important;
      width: 100% !important;
      height: 76px !important;
      min-height: 76px !important;
      margin: 0 !important;
      padding: 0 20px !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: #000 !important;
      box-shadow: 0 4px 8px rgba(52, 44, 35, 0.18) !important;
      color: #fff !important;
      font-family: inherit !important;
      font-size: 24px !important;
      font-weight: 400 !important;
      justify-content: center !important;
      align-items: center !important;
    }

    ${thankYouTypography}

    @media (max-width: 767px) {
      form { gap: 16px !important; }
      h1, h2, h3, [role='heading'] { font-size: 28px !important; }
      input:not([type='checkbox']):not([type='radio']),
      button[aria-labelledby*='current_projects'],
      button[type='submit'] {
        height: 64px !important;
        min-height: 64px !important;
      }
    }
  `;

  const contactStyles = `
    :host {
      --app-embed-padding-x: 0px !important;
      --app-embed-padding-y: 0px !important;
      --inline-container-max-width: 660px !important;
      --container-max-w: 660px !important;
      --form-field-border-radius: 0px !important;
      --button-border-radius: 0px !important;
      --form-field-border: none !important;
      --form-field-border-focused: 0 0 0 1px #202020 !important;
      display: block !important;
      width: 100% !important;
      direction: rtl !important;
      font-family: inherit !important;
    }

    [data-sizing='form-wrapper'],
    [role='dialog'],
    [class*='_inline_'],
    [class*='_gridItemContent_'] {
      width: 100% !important;
      max-width: none !important;
      padding-right: 0 !important;
      padding-left: 0 !important;
    }

    [class*='_formHeader_'] {
      margin: 0 0 32px !important;
    }

    h1, h2, h3, [role='heading'] {
      max-width: 620px !important;
      margin: 0 auto !important;
      color: #000 !important;
      font-family: inherit !important;
      font-size: 32px !important;
      font-weight: 500 !important;
      line-height: 1.35 !important;
      text-align: center !important;
    }

    form {
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      column-gap: 30px !important;
      row-gap: 24px !important;
      width: 100% !important;
      max-width: none !important;
      direction: rtl !important;
    }

    form > div:first-child {
      display: none !important;
    }

    [class*='_formFieldContainer_'] {
      display: flex !important;
      flex-direction: column !important;
      width: 100% !important;
      max-width: none !important;
    }

    [class*='_formFieldContainer_']:has(textarea)::before {
      display: none !important;
      content: none !important;
    }

    [class*='_formPhoneInputContainer_'],
    form > div:has(textarea),
    form > button[type='submit'] {
      grid-column: 1 / -1 !important;
    }

    [class*='_formPhoneInputContainer_'] {
      display: block !important;
      width: 100% !important;
    }

    .phone-country-selector {
      display: none !important;
    }

    label[for='first_name'],
    label[for='email'],
    label[for='phone_number'],
    label[id^='label-custom'] {
      position: static !important;
      order: -1 !important;
      margin: 0 0 8px !important;
      padding: 0 !important;
      transform: none !important;
      color: #000 !important;
      font-family: inherit !important;
      font-size: 16px !important;
      font-weight: 400 !important;
      line-height: 1.4 !important;
      text-align: right !important;
    }

    [class*='_formFieldContainer_']:has(input:required) > label::after,
    [class*='_formFieldContainer_']:has(textarea:required) > label::after,
    [class*='_formFieldContainer_']:has(input:required) label[for]::after,
    [class*='_formFieldContainer_']:has(textarea:required) label[for]::after,
    label[for='email']::after,
    label[for='phone_number']::after {
      content: ' *';
      color: #e02229;
    }

    input:not([type='checkbox']):not([type='radio']),
    textarea {
      box-sizing: border-box !important;
      width: 100% !important;
      height: 56px !important;
      min-height: 56px !important;
      padding: 0 16px !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: #fff !important;
      box-shadow: none !important;
      color: #000 !important;
      font-family: inherit !important;
      font-size: 16px !important;
      text-align: right !important;
    }

    textarea {
      height: 170px !important;
      min-height: 170px !important;
      padding-top: 16px !important;
      resize: vertical !important;
    }

    input::placeholder,
    textarea::placeholder {
      color: #8d8d8d !important;
      opacity: 1 !important;
    }

    input#email,
    input[type='email'] {
      direction: rtl !important;
      unicode-bidi: plaintext !important;
      text-align: right !important;
    }

    button[type='submit'] {
      display: flex !important;
      box-sizing: border-box !important;
      align-items: center !important;
      justify-self: center !important;
      width: 125px !important;
      min-width: 125px !important;
      height: 56px !important;
      min-height: 56px !important;
      margin-top: 16px !important;
      padding: 0 20px !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: #000 !important;
      box-shadow: none !important;
      color: #fff !important;
      font-family: inherit !important;
      font-size: 16px !important;
      font-weight: 600 !important;
      line-height: 1 !important;
      justify-content: center !important;
    }

    ${thankYouTypography}

    @media (max-width: 767px) {
      h1, h2, h3, [role='heading'] { font-size: 26px !important; }
      form { grid-template-columns: 1fr !important; row-gap: 20px !important; }
      form > * { grid-column: 1 !important; }
    }
  `;

  const prepareForm = (embed) => {
    const shadow = embed.shadowRoot;
    if (!shadow) return;

    syncReassurance(embed, shadow);
    capturePinterestContactData(embed, shadow);
    publishPinterestSubmission(embed, shadow);

    if (!shadow.getElementById(STYLE_ID)) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = styles;
      shadow.appendChild(style);
    }

    const phone = shadow.querySelector('#phone_number');
    if (phone) phone.placeholder = 'טלפון נייד';

    useShopifyLabelAsPlaceholder(
      shadow,
      shadow.querySelector("#first_name, input[autocomplete='name'], input[autocomplete='given-name']")
    );

    if (!embed.sofaGalleryShadowObserver) {
      embed.sofaGalleryShadowObserver = new MutationObserver(() => prepareForm(embed));
      embed.sofaGalleryShadowObserver.observe(shadow, {
        attributes: true,
        attributeFilter: ['data-current-step'],
        childList: true,
        subtree: true,
      });
    }
  };

  const prepareContactForm = (embed) => {
    const shadow = embed.shadowRoot;
    if (!shadow) return;

    syncReassurance(embed, shadow);
    captureContactFormData(embed, shadow);
    publishContactFormSubmission(embed, shadow);

    if (!shadow.getElementById(CONTACT_STYLE_ID)) {
      const style = document.createElement('style');
      style.id = CONTACT_STYLE_ID;
      style.textContent = contactStyles;
      shadow.appendChild(style);
    }

    const placeholders = {
      email: 'אימייל',
      phone_number: 'טלפון',
    };
    Object.entries(placeholders).forEach(([id, placeholder]) => {
      const field = shadow.getElementById(id);
      if (field) field.placeholder = placeholder;
    });
    useShopifyLabelAsPlaceholder(
      shadow,
      shadow.querySelector("#first_name, input[autocomplete='name'], input[autocomplete='given-name']")
    );
    const message = shadow.querySelector("textarea[name^='custom#']");
    if (message) message.placeholder = 'הודעה';

    if (!embed.sofaGalleryContactObserver) {
      embed.sofaGalleryContactObserver = new MutationObserver(() => prepareContactForm(embed));
      embed.sofaGalleryContactObserver.observe(shadow, {
        attributes: true,
        attributeFilter: ['data-current-step'],
        childList: true,
        subtree: true,
      });
    }
  };

  const prepareAllForms = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((embed) => {
      prepareForm(embed);
      if (embed.dataset.sofaGalleryObserved) return;

      embed.dataset.sofaGalleryObserved = 'true';
      new MutationObserver(() => prepareForm(embed)).observe(embed, {
        childList: true,
        subtree: true,
      });
    });
    document.querySelectorAll(CONTACT_ROOT_SELECTOR).forEach(prepareContactForm);
  };

  customElements.whenDefined('shopify-forms-embed').then(prepareAllForms);
  document.addEventListener('shopify:section:load', prepareAllForms);
  new MutationObserver(prepareAllForms).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
